import styled from "styled-components";

export const Description = styled.p`
  margin: 0 0 15px;
  font-size: 13px;
  line-height: 18px;
  color: ${({ theme }) => theme.black50};
`;

export const ExampleButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: -6px 0 15px;
`;

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
`;

export const FileName = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.textMain};
  word-break: break-all;
`;

export const ImportButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 15px 0 5px;
`;
